import Vue from 'vue';

export default [
    {
        pathId: 'tls',
        component: 'tools',
        title: 'Tools',
        icon: 'fa-tools',
        size: 'sm', //sm, md, lg, xl
    },
    {
        pathId: 'tlmm',
        component: 'mass-email',
        title: 'Mass E-Mail',
        icon: 'fa-envelope',
        size: 'lg', //sm, md, lg, xl
    },
    {
        pathId: 'tlrc',
        component: 'reseller-contact',
        title: 'Reseller Contact',
        icon: 'fa-envelope',
        size: 'lg', //sm, md, lg, xl
        loading: true
    },
    {
        pathId: 'fx',
        component: 'fax-list',
        title: 'Faxes & Documents',
        icon: 'fa-fax',
        size: 'lg',
        reload: true
    },
    {
        pathId: 'fxd',
        component: 'fax-detail',
        title: 'Document',
        icon: 'fa-fax',
        size: 'full',
        props: ['faxId'],
        reload: true,
        loading: true
    },
    {
        pathId: 'fxr',
        component: 'fax-reflections',
        title: 'Reflections',
        icon: 'fa-comment',
        size: 'md',
        props: ['enrollId'],
        reload: true,
        loading: true
    },
];

Vue.component('tools', () => import('@/cards/tools/Tools'));
Vue.component('mass-email', () => import('@/cards/tools/MassEmail'));
Vue.component('reseller-contact', () => import('@/cards/tools/ResellerContact'));
Vue.component('fax-list', () => import('@/cards/faxes/FaxList'));
Vue.component('fax-detail', () => import('@/cards/faxes/FaxDetail'));
Vue.component('fax-reflections', () => import('@/cards/faxes/Reflections'));
